import * as prismic from '@prismicio/client';

const client = prismic.createClient('react-routing-blogg');

export default client;
